var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgG2115(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_257_619)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_257_619",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 42,
    height: 42
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H42V42H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_257_619)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.3851 16.967C41.3851 15.6523 40.8628 14.3915 39.9332 13.4619C39.0036 12.5322 37.7427 12.01 36.4281 12.01H32.3881C31.8441 12.01 31.3224 11.7939 30.9378 11.4093C30.5532 11.0246 30.3371 10.5029 30.3371 9.95897V5.91898C30.3371 4.6043 29.8148 3.34347 28.8852 2.41385C27.9556 1.48423 26.6947 0.961975 25.3801 0.961975H24.5801",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.98633 23.784V3.013C9.9862 2.74362 10.0392 2.47683 10.1422 2.22794C10.2452 1.97904 10.3963 1.75289 10.5868 1.56241C10.7772 1.37193 11.0034 1.22088 11.2523 1.11786C11.5012 1.01483 11.768 0.961844 12.0373 0.961975H26.6793C29.0209 0.962 31.2666 1.89224 32.9223 3.548L38.7993 9.42499C40.4551 11.0807 41.3853 13.3264 41.3853 15.668V37.221C41.3853 37.7649 41.1692 38.2866 40.7846 38.6713C40.4 39.0559 39.8783 39.272 39.3343 39.272H14.4943",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5352 18.436H36.1202",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1202 22.278H33.6992",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.239 22.278H15.252",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.252 26.12H36.121",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1197 29.962H17.5527",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0112 33.804H17.7852",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.07555 25.478C5.74013 24.2312 7.79842 23.6263 9.87288 23.7744C11.9473 23.9224 13.8989 24.8134 15.3695 26.284C16.9902 27.905 17.9006 30.1033 17.9006 32.3955C17.9006 34.6876 16.9902 36.886 15.3695 38.507C13.7485 40.1276 11.5502 41.038 9.25805 41.038C6.96587 41.038 4.76755 40.1276 3.14655 38.507C1.67616 37.0366 0.785223 35.0854 0.637177 33.0113C0.48913 30.9372 1.0939 28.8792 2.34055 27.215",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.89062 33.327L8.49863 36.935L12.7476 28.517",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1367 11.03L19.0997 5.87498C19.1085 5.85313 19.1236 5.8344 19.1431 5.82121C19.1626 5.80801 19.1857 5.80096 19.2092 5.80096C19.2328 5.80096 19.2558 5.80801 19.2753 5.82121C19.2948 5.8344 19.3099 5.85313 19.3187 5.87498L21.2647 11.03",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.748 9.745H20.661",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2617 5.80096L26.9397 11.03",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.681 5.80096L22.998 11.03",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.498 5.80096H16.386",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9375 5.96698V11.029",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_257_619"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgG2115);
export default __webpack_public_path__ + "static/media/g2115.ddeebe8fd856c63d74c4495df8386050.svg";
export { ForwardRef as ReactComponent };